import { useAuth, useStore } from '@/containers'
import { CouponArrowDown, CouponIconSimple } from '@/styles/Icon'
import { useState } from 'react'

import ModalVoucherList from '../Popup/ModalVoucherList'
import FormRadioButtonItems from './FormRadioButtonItems'

interface FormDiscount {
  className?: string
  onClick?: () => void
  icon?: boolean
  disabled?: boolean
  isError?: boolean | string
  type?: 'button' | 'submit' | 'reset' | undefined
  typeButtonPrimary?: 'button' | 'submit' | 'reset' | undefined
  classButtonConfirm?: string
  id?: string
  name?: string
  value?: string
  primary?: boolean
  secondary?: boolean
  shippingMethod?: string
  discount?: number
}

const FormDiscount = ({ shippingMethod, discount = 0 }: FormDiscount) => {
  const { selectedLang } = useStore()

  const { errorAuth, cart } = useAuth()

  const [showListCoupons, setShowListCoupons] = useState(false)
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }

  return (
    <div className='discountBox bg-grey-200 rounded' id='voucher'>
      <div
        className=' relative flex h-12 w-full cursor-pointer flex-row items-center rounded border border-gray-100 bg-white'
        onClick={() => setShowListCoupons(true)}
      >
        <span className='icon mx-2'>
          <CouponIconSimple />
        </span>
        <span className='text-Headline leading-none tracking-tight'>
          Sử dụng mã giảm giá
        </span>
        <CouponArrowDown className='absolute right-2 top-[35%]' />
      </div>

      {!showListCoupons && cart?.coupons?.filter(e => e.mes).length > 0 && (
        <div className='mb-1 w-full text-mainBody font-normal leading-tight text-primary-second'>
          Một trong số các voucher không hợp lệ, tiếp tục mua hàng mà không cần
          voucher đó
        </div>
      )}
      {discount && discount > 0 ? (
        <div className='my-1 text-dark-400'>
          Đã áp dụng{' '}
          <strong>{cart?.coupons?.filter(e => !e.mes)?.length}</strong> mã (giảm{' '}
          <strong className={`font-bold text-primary-second`}>
            {discount
              ?.toLocaleString(selectedLang as string, {
                style: 'currency',
                currency: currency(selectedLang as string),
              })
              .replace(/\s₫/g, 'đ')}
          </strong>
          )
        </div>
      ) : (
        ''
      )}

      <div className='w-full overflow-y-auto'>
        <FormRadioButtonItems className='flex flex-wrap !gap-2 '>
          {!errorAuth?.status &&
            cart?.coupons &&
            cart.coupons
              .filter(e => !e.mes)
              .map((e, i) => {
                return (
                  <div
                    key={i}
                    className={`voucherItem flex h-[38px] w-full max-w-[135px] justify-center bg-[url('/assets/icons/couponApply.svg')] bg-cover bg-no-repeat`}
                  >
                    <span className='text-Voucher self-center text-primary-second'>
                      Giảm{' '}
                      {e.value
                        .toLocaleString(selectedLang as string, {
                          style: 'currency',
                          currency: currency(selectedLang as string),
                        })
                        .replace(/\s₫/g, 'đ')}
                    </span>
                  </div>
                )
              })}
        </FormRadioButtonItems>
      </div>
      <ModalVoucherList
        showListCoupons={showListCoupons}
        setShowListCoupons={setShowListCoupons}
        shippingMethod={shippingMethod}
      />
    </div>
  )
}

export default FormDiscount
